import { put, call, takeLatest, all, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetCurrentUser,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
} from '../types/user/get-current-user'
import { GetOneUser, GET_ONE_USER, GET_ONE_USER_SUCCESS, GET_ONE_USER_ERROR } from '../types/user/get-one'
import { GetAllUsers, GET_ALL_USERS, GET_ALL_USERS_SUCCESS, GET_ALL_USERS_ERROR } from '../types/user/get-all'
import { NewUser, NEW_USER, NEW_USER_SUCCESS, NEW_USER_ERROR } from '../types/user/new'
import { EditUser, EDIT_USER, EDIT_USER_SUCCESS, EDIT_USER_ERROR } from '../types/user/edit'
import { DeleteUserMedia, DELETE_USER_MEDIA, DELETE_USER_MEDIA_ERROR, DELETE_USER_MEDIA_SUCCESS } from '../types/user/delete-media'
import { UPDATE_CURRENT_USER_SUCCESS, UPDATE_CURRENT_USER_ERROR, UPDATE_CURRENT_USER, UpdateCurrentUser } from '../types/user/update-current-user'

const currentUser = ({ userStore }) => userStore.currentUser
const allUser = ({ userStore }) => userStore.all.data

function* newUser({ payload }: NewUser) {
  try {
    const { response, error } = yield call(services.user.new, payload)
    if (error) {
      yield put({
        type: NEW_USER_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: NEW_USER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: NEW_USER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* getCurrentUser() {
  try {
    const { response, error } = yield call(services.user.getProfile)
    if (error) {
      yield put({
        type: GET_CURRENT_USER_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_CURRENT_USER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_CURRENT_USER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* updateCurrentUser() {
  try {
    const { response, error } = yield call(services.user.getProfile)
    if (error) {
      yield put({
        type: UPDATE_CURRENT_USER_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({
          type: UPDATE_CURRENT_USER_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_CURRENT_USER_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: UPDATE_CURRENT_USER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* getUser({ payload }) {
  try {
    const { response, error } = yield call(services.user.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_USER_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_USER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_USER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* getAllUsers() {
  try {
    const { response, error } = yield call(services.user.getAll, {})
    if (error) {
      yield put({
        type: GET_ALL_USERS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_USERS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_USERS_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* editUser({ payload }: EditUser) {
  try {
    const { response, error } = yield call(services.user.edit, payload)

    if (error) {
      yield put({
        type: EDIT_USER_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllUsers = yield select(allUser)

      if (!!currentAllUsers) {
        const updatedCurrentAllUsers = currentAllUsers[0].results.map(user => {
          if (user._id === response._id) {
            return { ...user, ...response }
          } else {
            return user
          }
        })

        yield put({
          type: GET_ALL_USERS_SUCCESS,
          payload: { ...currentAllUsers, data: updatedCurrentAllUsers },
        })
      }

      yield put({
        type: EDIT_USER_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: EDIT_USER_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* deleteUserMedia({ payload }: DeleteUserMedia) {
  try {
    const { response, error } = yield call(services.user.deleteUserMedia, payload)

    if (error) {
      yield put({
        type: DELETE_USER_MEDIA_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: DELETE_USER_MEDIA_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_USER_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_USER_MEDIA_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneUser>(GET_ONE_USER, getUser)
  yield takeLatest<GetCurrentUser>(GET_CURRENT_USER, getCurrentUser)
  yield takeLatest<GetAllUsers>(GET_ALL_USERS, getAllUsers)
  yield takeLatest<NewUser>(NEW_USER, newUser)
  yield takeLatest<EditUser>(EDIT_USER, editUser)
  yield takeLatest<DeleteUserMedia>(DELETE_USER_MEDIA, deleteUserMedia)
  yield takeLatest<UpdateCurrentUser>(UPDATE_CURRENT_USER, updateCurrentUser)
  //yield takeLatest<any>(SIGN_IN_SUCCESS, getProfile)
  //yield takeLatest<SetUserInformation>(SET_USER_INFORMATION, setUserInformation)
  //yield takeLatest<SetUserInformation>(SIGN_IN_SUCCESS, setUserInformation)
}
